import AllPopups from './AllPopups.gql';

export default AllPopups;
